function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm5.169,6.374L7.431,12.112a.3.3,0,0,1-.425,0l-.848-.857c-.117-.117-.308-.309-.424-.428L3.761,8.753a.313.313,0,0,1-.089-.218.3.3,0,0,1,.089-.209l.865-.779a.3.3,0,0,1,.424,0l1.957,2a.3.3,0,0,0,.425,0L11.9,5.089a.3.3,0,0,1,.424,0l.848.857A.306.306,0,0,1,13.169,6.374Z",
  fill: "#339b40"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/check.72bf575d.svg";
export { SvgComponent as ReactComponent };